import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import PortRestrictionsApproval from './PortRestrictionsApproval';
import PortRestrictionsForm from './PortRestrictionsForm';
import PortRestrictionsView from './PortRestrictionsView';
import { hasChanges } from '../../common/utils';
import { BlockWrapper } from '../../common/BlockWrapper';
import get from 'lodash/get';

const PortRestrictions = ({
    port,
    pendingChanges,
    onApproveField,
    onRejectField,
    updatePortField,
}) => {
    const [isEditing, setIsEditing] = useState(false);

    const processedStatus = get(pendingChanges, 'processedFields.portLimitations.status');

    const isApproved = processedStatus === 'approved';
    const isRejected = processedStatus === 'rejected';

    const hasPortRestrictionChanges = 
        !isApproved &&
        !isRejected &&
        hasChanges(
            get(pendingChanges, 'originalValues.portLimitations'), 
            get(pendingChanges, 'changedValues.portLimitations'),
        );

    const saveChanges = async (change) => {
        updatePortField('portLimitations', change, () => {
            setIsEditing(false);
        });
    };

    if (hasPortRestrictionChanges) {
        return (
            <BlockWrapper title='Port Restrictions'>
                <PortRestrictionsApproval 
                    originalValues={pendingChanges.originalValues.portLimitations || {}}
                    changedValues={pendingChanges.changedValues.portLimitations || {}}
                    onApprove={onApproveField}
                    onReject={onRejectField}
                />
            </BlockWrapper>
        );
    }

    return (
        <BlockWrapper title='Port Restrictions'>
            <div className="port-restrictions-block">
                {isEditing ? (
                    <PortRestrictionsForm 
                        initialValues={{ portLimitations: port.portLimitations }}
                        onSubmit={(values) => {
                            saveChanges(values.portLimitations);
                        }}
                        onCancel={() => setIsEditing(false)}
                    />
                ) : (
                    <React.Fragment>
                        <PortRestrictionsView values={port.portLimitations} />
                        <div className="form-actions">
                            <RaisedButton
                                label="Edit Port Restrictions"
                                onClick={() => setIsEditing(true)}
                                primary
                            />
                        </div>
                    </React.Fragment>
                )}
            </div>
        </BlockWrapper>
    );
};

PortRestrictions.propTypes = {
    port: PropTypes.shape({
        portLimitations: PropTypes.object,
    }).isRequired,
    pendingChanges: PropTypes.shape({
        originalValues: PropTypes.shape({
            portLimitations: PropTypes.object,
        }),
        changedValues: PropTypes.shape({
            portLimitations: PropTypes.object,
        }),
    }),
    onApproveField: PropTypes.func.isRequired,
    onRejectField: PropTypes.func.isRequired,
    onSaveChanges: PropTypes.func.isRequired,
};

export default PortRestrictions;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictions.jsx